import { createSlice } from '@reduxjs/toolkit';
import { TabBarState } from '../../pages/types';

export enum Tabs {
  first = 'first',
  second = 'second',
  third = 'third',
  fourth = 'fourth',
  fifth = 'fifth',
}

const initialState: TabBarState = {
  isActive: false,
  activeTab: Tabs.first,
};

const tabBarReducer = createSlice({
  name: 'tabBar',
  initialState: initialState,
  reducers: {
    setActiveTab(state, action: { type: string; payload: Tabs }) {
      state.activeTab = action.payload;
    },
    setIsActive(state, action: { type: string; payload: boolean }) {
      state.isActive = action.payload;
    },
  },
});

export const { setActiveTab, setIsActive } = tabBarReducer.actions;
export default tabBarReducer.reducer;
